{
  "email": "Please enter a valid email address",
  "maxLength": "{{field}} must be no more than {{count}} characters",
  "minLength": "{{field}} must be at least {{count}} characters",
  "passwordsMustMatch": "Passwords must match",
  "required": "{{field}} is required"
}
